import { Component, input } from '@angular/core';
import { RoundedPipe } from 'ev-core';
import { EvTooltipModule } from 'ev-tooltip';
import { DemographyTooltip } from '../buyer-demography.component';

@Component({
  selector: 'single-value',
  imports: [RoundedPipe, EvTooltipModule],
  templateUrl: './single-value.component.html',
  styleUrl: './single-value.component.scss',
})
export class SingleValueComponent {
  valuesData = input<SingleValue>(null);
  tooltip = input<DemographyTooltip>(null);
}


export interface SingleValue {
    text: string;
    share: number;
    num: number;
}